export const pick = (obj, key, lang) => (lang === "en" && obj?.[`${key}_en`]) || obj?.[key] || "";

export const pickList = (obj, key, lang) => {
  const en = obj?.[`${key}_en`];
  return lang === "en" && Array.isArray(en) && en.length ? en : obj?.[key] || [];
};

const CATEGORIES_EN = {
  "Business του Γυμναστή": "Trainer Business",
  "Αποκατάσταση & Υγεία": "Rehab & Health",
  "Διατροφή": "Nutrition",
  "Δωρεάν δείγμα": "Free sample",
  "Ειδικοί Πληθυσμοί": "Special Populations",
  "Επαγγελματικά": "Professional",
  "Πακέτα": "Bundles",
  "Προπονητική": "Coaching",
  "Φυσιολογία & Προπόνηση": "Physiology & Training",
  "Ψυχολογία": "Psychology",
  "Ποδόσφαιρο": "Football",
  "Μπάσκετ": "Basketball",
  "Fitness & Business": "Fitness & Business",
};

const LEVELS_EN = {
  "Όλα τα επίπεδα": "All levels",
  "Αρχάριο": "Beginner",
  "Μέσο": "Intermediate",
  "Μεσαίο": "Intermediate",
  "Προχωρημένο": "Advanced",
  Beginner: "Beginner",
  Foundation: "Foundation",
  Intermediate: "Intermediate",
  Advanced: "Advanced",
  Path: "Learning Path",
};

const LEVELS_EL = { Beginner: "Αρχάριο", Foundation: "Βασικό", Intermediate: "Μεσαίο", Advanced: "Προχωρημένο", Path: "Μονοπάτι" };

export const catLabel = (cat, lang) => (lang === "en" ? CATEGORIES_EN[cat] || cat : cat) || "";
export const levelLabel = (lvl, lang) => (lang === "en" ? LEVELS_EN[lvl] || lvl : LEVELS_EL[lvl] || lvl) || "";
